import fetch from '../utils/fetch'

export function searchAPI(data) {
    return fetch({
        url:  '/achievement/search',
        method: "get",
        params: data,
    })
}
